import { render, staticRenderFns } from "./ActicityPageFour.vue?vue&type=template&id=1fb72c98&scoped=true&"
import script from "./ActicityPageFour.vue?vue&type=script&lang=js&"
export * from "./ActicityPageFour.vue?vue&type=script&lang=js&"
import style0 from "./ActicityPageFour.vue?vue&type=style&index=0&id=1fb72c98&scoped=true&lang=css&"
import style1 from "./ActicityPageFour.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb72c98",
  null
  
)

export default component.exports